import React from 'react';
import { Badge, Tooltip } from '@shopify/polaris';
import { StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';
import { useCurrentApp } from '@/stores/userDataStore';

interface LiveBadgeProps {
  video: StudioVideo;
}

const LiveBadge: React.FC<LiveBadgeProps> = ({ video }) => {
  const { appUrl } = useCurrentApp();

  const isPublished = video.publishedIn?.some((published) => published.appUrl === appUrl);

  if (!isPublished) {
    return null;
  }

  return (
    <div className="absolute right-2 top-2">
      <Tooltip content="Published on your Tolstoy Projects">
        <Badge
          tone="success"
          progress="complete"
          toneAndProgressLabelOverride="Status: Video asset published on your Tolstoy Projects."
        >
          Live
        </Badge>
      </Tooltip>
    </div>
  );
};

export default LiveBadge;
